export type FontFamily = (typeof fontFamilies)[number];

export const fontFamilies = [
  'Archivo Narrow',
  'Arial',
  'BioRhyme',
  'Caveat',
  'Comic Neue',
  'Courier Prime',
  'Dosis',
  'DM Mono',
  'DM Sans',
  'Eczar',
  'Georgia',
  'Hanken Grotesk',
  'IBM Plex Mono',
  'IBM Plex Sans',
  'IM Fell English',
  'Impact',
  'Inconsolata',
  'Inknut Antiqua',
  'Inter',
  'Jost',
  'Kreon',
  'Lato',
  'Lora',
  'Lucida Grande',
  'Merriweather',
  'Montserrat',
  'Odin Rounded',
  'Oswald',
  'OpenDyslexic',
  'OpenDyslexicMono',
  'Open Sans',
  'Palatino',
  'Pangolin',
  'Playfair Display',
  'Plus Jakarta Sans',
  'Pompiere',
  'Poppins',
  'Princess Sofia',
  'Proza Libre',
  'Questrial',
  'Raleway',
  'Roboto',
  'Roboto Slab',
  'Shadows Into Light Two',
  'Space Grotesk',
  'Space Mono',
  'Source Sans 3',
  'Source Serif 4',
  'Syne Mono',
  'Times New Roman',
  'Trebuchet MS',
  'Varela Round',
  'Verdana',
  'Work Sans',
] as const;

export type FontSize = (typeof fontSizes)[number];

export type AnyFontSize = `${number}px`;

export const fontSizes = [
  '10px',
  '13px',
  '15px',
  '16px',
  '18px',
  '24px',
  '28px',
  '32px',
  '36px',
  '48px',
  '64px',
  '96px',
  '128px',
] as const;

export const fontSizesAsNumbers = fontSizes.map((size) => parseFloat(size.replace('px', '')));

export type FontSizesAsNumbers = (typeof fontSizesAsNumbers)[number];

export type FontWeight = (typeof fontWeights)[number];

export const fontWeights = ['regular', 'bold'] as const;

export type FontStyle = (typeof fontStyles)[number];

export const fontStyles = ['italic'] as const;
